export default {
    install: function (Vue, options) {
        Vue.prototype.$acl = options.handler;
    }
};



// WEBPACK FOOTER //
// ./src/lib/plugins/acl.ts